/**
 * This module increases the height of the text areas.
 */
export default function enableEditionMode() {
  const $formHeader = $( '.o__ime-form-header' );
  const attrEditMode = 'data-edit-mode';
  const attrEditFieldFlag = 'data-edit-field';
  const isEditMode = $formHeader.attr( attrEditMode );
  const attrEditFieldFlagValue = $formHeader.attr( attrEditFieldFlag );
  const $editFlagField = $( `#${attrEditFieldFlagValue}` );

  $editFlagField.val( isEditMode );
}